import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useEffectOnUpdate from '../../hooks/useEffectOnUpdate';
import Field from './Field';
import './_styles_/CheckboxField.css';
import { extendedStateType } from '../../types';
import { NO_STATE } from '../../hooks/useExtendedState';
import { resolveValue } from '../../utils/fields';

CheckboxField.propTypes = {
    label: PropTypes.node,
    icon: PropTypes.string,
    iconTooltip: PropTypes.string,
    iconMiddlewares: PropTypes.arrayOf(PropTypes.shape({ offset: PropTypes.shape({ mainAxis: PropTypes.number, crossAxis: PropTypes.number }) })),
    value: PropTypes.bool,
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    isRequired: PropTypes.bool,
    isDisabled: PropTypes.bool,
    state: extendedStateType,
};

function CheckboxField(props) {
    const {
        label = null,
        icon = null,
        iconTooltip = null,
        iconMiddlewares,
        inputId = null,
        value,
        onChange,
        className = '',
        onReset,
        isChanged,
        isRequired = false,
        isDisabled = false,
        state = NO_STATE,
    } = props;
    const resolvedValue = resolveValue(value, state);
    const stateValueSetter = state && state !== NO_STATE ? state.setValueIfNew : () => {};
    const [displayedValue, setDisplayedValue] = useState(resolvedValue);
    const setNewValue = (newValue) => {
        setDisplayedValue(newValue);
        stateValueSetter(newValue);
        onChange && onChange(newValue);
    };
    useEffectOnUpdate(() => {
        setNewValue(resolveValue(value, state));
    }, [value, state.value]);
    const onChangeHandler = (event) => setNewValue(event.target.checked);
    return (
        <Field
            label={label}
            icon={icon}
            iconTooltip={iconTooltip}
            iconMiddlewares={iconMiddlewares}
            inputId={inputId}
            onReset={onReset}
            isChanged={isChanged}
            state={state}
            isRequired={isRequired && !displayedValue}
        >
            <input
                type="checkbox"
                id={inputId}
                className={className}
                checked={displayedValue}
                onChange={onChangeHandler}
                disabled={isDisabled}
            />
        </Field>
    );
}

export default CheckboxField;
